import {HeaderTitle, Icon, LinkText} from '@/components/atoms'
import {useState} from 'react'
import {DynamicColumnTable} from '@/components/organisms'
import {useWarehouseTargets} from '@/pages/ProductsPages/Fullfillment/Warehouse/useWarehouseTargets'
import {useWarehouseUploadHistory} from '@/pages/ProductsPages/Fullfillment/Warehouse/useWarehouseHistory'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {Header} from '@/utils/constants/header'

import {UploadHistoryTableModal} from '@/components/organisms'

const cellDataMapperObj = {
  warehouseName: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText
          text={original?.warehouseName}
          id={original?.warehouseName + ' ' + original?.id}
          handleClick={() => {}}
        />
      </div>
    )
  },
}

/**
 * Column definitions for the sub-table
 */
const subColumns = [
  {
    columnKey: 'id',
    header: 'ID',
  },
  {
    columnKey: 'status',
    header: 'Status (REMARK)',
  },
]

/**
 * Column definitions for the main table
 */
const mainColumns = [
  {columnKey: 'file_path', header: 'FILE PATH'},
  {columnKey: 'import_date', header: 'IMPORT DATE'},
  {columnKey: 'job_start_date', header: 'JOB START DATE'},
  {columnKey: 'job_end_date', header: 'JOB END DATE'},
  {
    columnKey: 'total_records',
    header: 'STATISTICS',
    cellData: ctx => (
      <div className="flex flex-col">
        <div>{ctx.row.original.total_records}</div>
        {ctx.row.original.failed_records_count > 0 && (
          <div className={`failed-tests ${ctx.row.original.id}`} style={{color: 'red', fontWeight: 'bold'}}>
            {ctx.row.original.failed_records_count} Failed
          </div>
        )}
      </div>
    ),
  },
]



const WarehouseList = () => {
  const [rowSelected, setRowSelected] = useState([])
  const {warehouseTargetsData, warehouseTargetsColConfigData} = useWarehouseTargets()
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj, warehouseTargetsColConfigData)
  const {warehouseUploadHistoryData} = useWarehouseUploadHistory()

  const [openUploadHistory, setOpenUploadHistory] = useState(false)

  return (
    <div className="warehouseTargetsDataTable">
      <div className="relative" style={{backgroundColor: '#1D1D1D'}}>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title="Warehouse List"
          className="warehouseDataTableHeading  pl-4 pr-4"
        />
        <span className="warehouseSettingsIcon absolute h-8 w-8 rounded p-2">
          <Icon icon="settings" isDark={true} size="small" className="h-4 w-4" />
        </span>
        {warehouseTargetsData?.data?.length && warehouseTargetsColConfigData.length && (
          <DynamicColumnTable
            columns={cellDataMappedCols || []}
            records={warehouseTargetsData?.data || []}
            rowSelection={rowSelected}
            setRowSelection={setRowSelected}
            toolbarActions={[
              {
                text: 'View Upload History',
                variant: 'secondary',
                onClick: () => {
                  setOpenUploadHistory(true)
                },
              },
              {
                text: 'Download',
                variant: 'secondary',
                onClick: () => {
                  alert('Download')
                },
              },
            ]}
          />
        )}
        {warehouseTargetsData?.totalRecords && (
          <div className="txtRightAlign">{warehouseTargetsData?.totalRecords} total items</div>
        )}
      </div>

      <UploadHistoryTableModal
        openUploadHistory={openUploadHistory}
        setOpenUploadHistory={setOpenUploadHistory}
        mainData={warehouseUploadHistoryData}
        mainColumns={mainColumns}
        subData={warehouseUploadHistoryData.flatMap(item =>
          item.failed_records.map(record => ({
            ...record,
            parentId: item.id,
          }))
        )}
        subColumns={subColumns}
        isDark={true}
      />

    </div>
  )
}

export default WarehouseList
